import Card from "../UI/Card";
import ExternalLink from "../UI/ExternalLink";

const Projects = ({projects}) => {
    return ( 
        <div className="cards-row">
           {projects && projects.map((item)=>
           (<Card key={item.id} className="cardBody">
               <div className="card-items">
               <h3>{item.title}</h3>
               <p>{item.description}</p>
               {item.techStack && <h5>Tech Stack: {item.techStack}</h5>}
               <div className="project-externalLinks">
               { item.URL && <ExternalLink href={item.URL} className="project-code-link" title="VIEW LIVE"/>}
               { item.sourceCode && <ExternalLink href={item.sourceCode} className="project-live-link" title="SOURCE CODE"/>}
               </div>
               </div>
           </Card>)
           )}
        </div>
     );
}
 
export default Projects;